import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../Box/index.js";
import FormValidationMessage_styles from "./FormValidationMessage.styles.js";
const FormValidationMessage = (t0)=>{
    const $ = c(8);
    const { title, children } = t0;
    const { classes } = FormValidationMessage_styles();
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ jsx(Box, {
            mb: "4",
            children: title
        });
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            p: "16",
            bgcolor: "bg.greyscale.primary",
            radius: "l",
            children: [
                t1,
                children
            ]
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== classes.message || $[6] !== t2) {
        t3 = /*#__PURE__*/ jsx("div", {
            className: classes.message,
            children: t2
        });
        $[5] = classes.message;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
export { FormValidationMessage };
